import styled, { css } from "styled-components";
import { PrimaryButtonComponent, GhostButtonComponent } from "../../../../CommonComponents/commonStyles";
import { Affix, Button, Col } from "antd";

const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

const cursorPointer = css`
  cursor: pointer;
`;

export const NoChange = styled.div`
  ${fontCommonStyle};
  line-height: 1.13;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 7px;
  }
`;


export const NoChangeSpace = styled(NoChange)`
  margin-bottom: 45px;
  width: 343px;
  display: flex;
  margin-top: -3.25rem;
  justify-content: space-between;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: 0;
  }
`;

export const PagesHeadingWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: ${props => props.theme.lineHeight.pageHeading};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2};
    line-height: ${props => props.theme.lineHeight.h2};
    color: ${props => props.theme.fontColors.headingColor};
    font-weight: ${props => props.theme.fontWeight.normal};
    margin-bottom: 20px;
  }
`;
export const PageHeadingWrapper = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: ${props => props.theme.lineHeight.pageHeading};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2};
    line-height: ${props => props.theme.lineHeight.h2};
    color: ${props => props.theme.fontColors.headingColor};
    font-weight: ${props => props.theme.fontWeight.normal};
    margin-bottom: 20px;
  }
`;

export const ContentContainerSpaceSmall = styled.div`
  padding: 0 30px 0 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 0 0 0;
  }
`
export const Content = styled.div`
    ${fontCommonStyle}
    padding: 15px 0 30px 0px;
    width: 75%;
    line-height: 1.5;
    > div {
      > p {
        margin-bottom: 0;
      }
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      width: 100%;
      font-size: 14px;
      padding: 5px 0 20px 0px;
      line-height: 1.43;
    }
`;

export const FixedWidth = styled.div`
max-width: 1180px;
margin: 0 auto;
margin-bottom: -30px;
@media (max-width: 1440px) {
  padding-left: 25px;
  padding-right: 25px;
}
@media (max-width: 576px) {
  padding-left: 20px;
  padding-right: 20px;
}
`;

const titleCommmon = css`
  ${fontCommonStyle}
  line-height: 1.25;
  letter-spacing: 0.6px;
  font-weight: normal;
`;
export const TitleWrapper = styled.div`
  ${titleCommmon}
  margin-bottom: 10px;
  margin-top: 6px;
`;

export const InputWrapperDrop = styled.div`
  .ant-select-selection--single {
    height: 40px;
  }
  .ant-select-selection-selected-value,
  .ant-select-search__field {
    line-height: 38px;
    vertical-align: middle;
    font-size: 16px;
    div {
      font-size: 16px;
    }
  }

  .ant-select-selection__placeholder {
    font-size: 16px;
    color: #d4d4d4;
    padding: 0 9px;
  }
  .ant-select-selection {
    border-radius: 0;
    border: 1px solid #d4d4d4;
  }

  .ant-select-selection {
    box-shadow: none;
  }

  .ant-select-selection__rendered {
    height: 100%;
    padding: 0 9px;
  }

  .ant-select-arrow {
    color: #606060;
    width: 40px;
    height: 100%;
    top: -1px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #d4d4d4;
    background: #f5f5f5;
  }
`;

export const NoResultsWrap = styled.div`
  margin-left: 11px;
`;

export const SelectOptionWrapper = styled.div`
  font-family: HelveticaNeue;
  color: #606060;
  font-size: 14px;
  line-height: 2.15;
  padding: 2px 0;
  font-weight: normal;
`;

export const SelectOptionMainWrapper = styled.div`
  .ant-select-dropdown {
    border: 1px solid #d4d4d4;
    border-top: none;
    border-radius: 0;
    box-shadow: -7px 9px 15px 0 rgba(223, 223, 223, 0.5);
    li {
      border: none;
      background-color: #ffffff;
    }
    li:hover {
      color: #167f91;
      background-color: #e6f7ff;
    }
  }

  .ant-select-dropdown:after {
    bottom: 0;
  }
`;

const buttonCommon = css`
  width: auto;
  min-width: 150px;
  ${cursorPointer};
`;

export const PrimaryButtonComponentNext = styled(PrimaryButtonComponent)`
  width: ${props => props.width ? props.width : '150px'};
  text-align: center;
  border-radius: 0;
  float:right;
  margin-bottom: 30px;
  &.ant-btn[disabled]{
    background-color: #d4d4d4 !important;
    opacity: 0.5;
    color: #505050;
  }
  &.ant-btn[disabled]:hover{
    background-color: #d4d4d4 !important;
    opacity: 0.5;
    color: #505050;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0;
    margin-bottom: 30px;
    font-size:16px;
    letter-spacing: 0.5px;
    font-family: HelveticaNeue-CondensedBold;
  }
`;

export const GhostButton = styled(GhostButtonComponent)`
width: ${props => props.width ? props.width : '150px'};
margin-right: 15px;
padding: 0 20px;
font-size: ${props => props.theme.fontSize.primary};
letter-spacing: ${props => props.theme.letterSpacing.normal};
@media only screen and (min-width: 320px) and (max-width: 991px) {
  width: ${props => props.mobHalfWidth ? "48%" : "100%"};;
  margin-right: 0;
  margin-bottom: 15px;
  &:last-child {
    margin-right: 0;
  }
    margin: 0 15px 15px 0;
    flex: 1;
  }

`;

export const SummaryDetailsWrapper = styled.div`
  margin-top:-2px;
`

export const CollapseWrap = styled.div`
    margin-bottom: 20px;
    .ant-collapse {
        background: #ffffff;
        border-radius: 0px;
    }

    .ant-collapse-content {
        border-top: none;
    }
`

export const PillButtonSelect = styled(Button)`
  color: #006778;
  background-color: #ffffff;
  font-family: HelveticaNeue-Medium;
  font-size: 14px;
  padding: 5px 35px;
  border-radius: 18px;
  box-shadow: 0;
  height: unset;
  border-color: #d4d4d4;
  &:hover, &:focus{
    color: #006778 !important;
    border: 1px solid #d4d4d4 !important;
    background-color: #ffffff !important;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    border-radius: 18px;
  }
`;

export const SaveAndContinueButton = styled(Button)`
  margin: 0 0 0 26px;
  color: #ffffff;
  background-color: #006778;
  font-family: HelveticaNeue-Medium;
  font-size: 14px;
  padding: 6px 23px;
  border-radius: 18px;
  box-shadow: 0;
  &:hover, &:focus{
    color: #ffffff !important;
    border: 1px solid #d4d4d4 !important;
    background-color: #006778 !important;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 0 0;
  }
`;

export const AccordionBorder = styled.div`
 border: 1px solid #d4d4d4;
 margin-bottom: 20px;
`

export const ContentContainer = styled.div`
padding: 0.75rem 9% 0 9%;
margin-bottom: ${props => props.marginBottom};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  padding: 0.5% 6.1% 0 6.1%;
}
  `;
export const AffixZ =styled(Affix)`
  z-index:-1;
    .ant-affix{
      z-index:-1;  
    }
`;

export const ComponentWrapper = styled(Col)`
  margin-top: 20px;
`;

export const StepperWrapper = styled.div`
  margin-top: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 40px;
  }
`;

export const StepDescriptionWrapper = styled.div`
  white-space: normal !important;
`;